<template>
    <div class="language-switcher" v-if="supportedLocales.length > 1">
        <v-select class="custom"
                  v-model="locale"
                  :items="supportedLocales"
                  item-text="title"
                  item-value="name" attach=".language-switcher"
                  :menu-props="{ contentClass: 'language-switcher-list' }"
                  @change="changeLanguage">
            <template v-slot:selection="{ item }">
                <div class="d-flex justify-space-between align-center" style="width: 100%">
                    <div class="d-flex align-center">
                        <img :src="localeImage(item.icon)" :alt="item.title">
                        <span>{{ item.title }}</span>
                    </div>
                    <div>
                        <v-icon>{{ mdiMenuDown }}</v-icon>
                    </div>
                </div>
            </template>
            <template v-slot:item="{ item }">
                <router-link class="d-flex align-center"
                             :to="localeLink(item)"
                             event="" @click.native.prevent=""
                             v-if="mustLocaleHaveLink(item)">
                    <img :src="localeImage(item.icon)" :alt="item.title">
                    <span>{{ item.title }}</span>
                </router-link>

                <div class="d-flex align-center" v-else>
                    <img :src="localeImage(item.icon)" :alt="item.title">
                    <span>{{ item.title }}</span>
                </div>
            </template>
        </v-select>

        <div v-for="locale in supportedLocales" v-if="showBasicLinks" class="language_switcher">
            <a :href="localeLink(locale)" v-if="mustLocaleHaveLink(locale)">{{ locale.title }}</a>
        </div>
    </div>
</template>

<script>
import {changeLocale} from "../../util/locale";
import {brandName} from "../../../config/app";
import {defaultLanguage, publicAppLocales} from '../../../config/localization';

import {mdiMenuDown} from '@mdi/js';

export default {
    name: "LanguageSwitcher",

    data: function () {
        return {
            locale: this.$store.state.locale,
            supportedLocales: publicAppLocales,
            showBasicLinks: true,
            mdiMenuDown: mdiMenuDown
        };
    },

    mounted() {
        this.showBasicLinks = false;
    },

    computed: {
        page() {
            let pageData = this.$store.getters.getPageData(this.$route);

            return pageData && pageData.page;
        },
    },

    methods: {
        mustLocaleHaveLink(locale) {
            return this.page && (!Array.isArray(this.page.allowedLocales) || this.page.allowedLocales.includes(locale.name)) && locale.name.toLowerCase() !== this.$store.state.locale;
        },

        localeLink(locale) {
            let localeName = locale.name;
            let routeLocale = localeName === defaultLanguage ? null : localeName.toLowerCase();

            let routeParams = {
                locale: routeLocale,
            };
            
            if (this.page && this.page.slug && this.page.slug[localeName]) {
                routeParams.slug = this.page.slug[localeName];
            } else {
                routeParams.slug = null;
            }

            let localeRoute = this.$router.resolve({
                params: routeParams,
                query: this.$route.query,
                hash: this.$route.hash,
            });

            return decodeURIComponent(localeRoute.resolved.fullPath);
        },

        localeImage(image) {
            return `/public/${brandName}/locale/${image}`;
        },

        changeLanguage(localeName) {
            changeLocale(this.$router, localeName, this.$cookies, this.$store);
        },
    },
}
</script>

<style lang="sass">
@import "sass/components/layout/LanguageSwitcher"
</style>